import styled from 'styled-components';
import { FlexColumn } from '../Flex';

export const InfoContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[2]};
  padding-top:${theme.padding[4]};
  padding-bottom:${theme.padding[8]};
`}`;

export const InfoContainerUnpadded = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[2]};
  padding-bottom:${theme.padding[2]};
`}`;
